export default __webpack_public_path__ + "static/media/Parametry Router Mikrotik.1e3a73d4.pdf";